import axios from 'axios';
import store from '../../store';
import getTeamUsers from '../GetTeamUsers';

export const USER_ACCEPTED = 'USER_ACCEPTED';

const acceptUser = (teamId, userId) => (
  dispatch => (
    axios.post(`/api/teams/${teamId}/users/${userId}`, {
      role: 'user',
    })
      .then(() => {
        dispatch({
          type: USER_ACCEPTED,
          teamId,
          userId,
        });
        store.dispatch(getTeamUsers(teamId));
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      })
  )
);

export default acceptUser;
